import React from 'react';

const LearningCourses = () => {
  return (
    <main style={{ padding: 40 }}>
      <h1>AILYT Learning — Courses</h1>
      <p>Course categories: English Speaking, Computer Courses, Data & Tech.</p>
    </main>
  );
};

export default LearningCourses;
